// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 35) return "static/chunks/35.b5ec7baa508d9334.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"700":"b2def4d928d28b2a","875":"eb6fab29362a2e3d"}[chunkId] + ".js";
};